import * as React from 'react';

import type { TypographyProps } from '@coursera/cds-core';

import { MetadataTypography } from 'bundles/program-loggedin-shared/components/Metadata';

import _t from 'i18n!nls/program-loggedin-shared';

/** Whether a course is elective or required */
const RequirementType = ({ isElective, color }: { isElective: boolean; color?: TypographyProps['color'] }) => (
  <MetadataTypography inline color={color}>
    {isElective ? _t('Elective') : _t('Required')}
  </MetadataTypography>
);

export default RequirementType;
